// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/aska/Documents/code/filmpartner/web/src/models/plan';
import model_2 from '/Users/aska/Documents/code/filmpartner/web/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'plan', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
